'use client';

import { Menu } from 'lucide-react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

import { KingsyardLogoMark } from '@/components/KingsyardLogo';
import { useEffect, useState } from 'react';

// 与 /resources 页头保持一致的四项导航
const NAV_LINKS = [
  { label: 'BIRDING GUIDE', href: '/birding-guide' },
  { label: 'FUN FACTS', href: '/fun-facts' },
  { label: 'RESOURCE HUB', href: '/resources' },
  { label: 'BIRDING BLOG', href: '/blog' },
];

export const SiteHeader = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const pathname = usePathname();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const isCurrent = (href: string) => pathname === href || pathname?.startsWith(`${href}/`);

  return (
    <header
      className={`sticky top-0 z-[100] border-b border-[#e8e6e2] bg-white transition-shadow ${
        scrolled ? 'shadow-[0_2px_12px_rgba(0,0,0,0.08)]' : ''
      }`}
    >
      <div className='relative flex h-16 items-center justify-center px-4 min-[900px]_justify-between min-[900px]_px-4 min-[1025px]_px-5 min-[1121px]_px-8'>
        <Link
          href='https://www.kingsyard.com'
          className='absolute left-1/2 flex shrink-0 -translate-x-1/2 items-center min-[900px]_static min-[900px]_translate-x-0'
        >
          <KingsyardLogoMark className='h-[34px] w-auto min-[1025px]_h-10' />
        </Link>

        {/* 间距随宽度收紧，字号字距保持 14px / 1px 不变 */}
        <nav className='hidden min-w-0 flex-nowrap items-center gap-4 min-[900px]_flex min-[1025px]_gap-[22px] min-[1121px]_gap-8'>
          {NAV_LINKS.map(link => (
            <Link
              key={link.href}
              href={link.href}
              className={`whitespace-nowrap font-poppins text-[14px] font-semibold tracking-[1px] no-underline transition-colors hover_text-primary ${
                isCurrent(link.href) ? 'text-primary' : 'text-[#1a1a1a]'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <button
          type='button'
          aria-label='Menu'
          onClick={() => setMenuOpen(prev => !prev)}
          className='absolute right-4 cursor-pointer border-none bg-transparent p-2 min-[900px]_hidden'
        >
          <Menu className='h-6 w-6 text-[#1a1a1a]' />
        </button>

        <Link
          href='https://www.kingsyard.com/bird-feeders'
          className='hidden shrink-0 whitespace-nowrap rounded-md bg-primary px-3.5 py-2 font-poppins text-sm font-semibold text-white no-underline transition-colors hover_bg-[#245027] min-[900px]_inline-block min-[1025px]_px-[18px] min-[1121px]_px-6'
        >
          Shop Now
        </Link>
      </div>

      {menuOpen && (
        <div className='border-b border-[#e8e6e2] bg-white px-4 py-4 shadow-[0_4px_12px_rgba(0,0,0,0.1)] min-[900px]_hidden'>
          {NAV_LINKS.map(link => (
            <Link
              key={link.href}
              href={link.href}
              onClick={() => setMenuOpen(false)}
              className={`block border-b border-[#e8e6e2] py-3 font-poppins text-[15px] font-semibold no-underline hover_text-primary ${
                isCurrent(link.href) ? 'text-primary' : 'text-[#1a1a1a]'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            href='https://www.kingsyard.com/bird-feeders'
            onClick={() => setMenuOpen(false)}
            className='mt-4 block rounded-md bg-primary px-6 py-3.5 text-center font-poppins text-[15px] font-semibold text-white no-underline hover_bg-[#245027]'
          >
            Shop Now
          </Link>
        </div>
      )}
    </header>
  );
};

export default SiteHeader;
